export default __webpack_public_path__ + "static/media/56.a83dacb0.png";